import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Documents from '../../../../../components/ui/Documents/Documents';
import { texts } from '../../../../../constants/texts';
import { getQueryKeys } from '../../../../../queries/queryKeys';
import useFlatAttachments from '../../../../../queries/useFlatAttachments';
import getFlatAttachment from '../../../../../requests/getFlatAttachment';
import { getBlobUrl } from '../../../../../../../helpers/getBlobUrl';
import { docEntities } from '../../../../../constants/common';
import useChangeDocModalVisible from '../../../../../hooks/useChangeDocModalVisible';
import { useDeleteDocMutation } from '../../../../../mutations/useDocMutations';
import styles from '../Flat.module.scss';
import useFlatsGridState from '../../../../../hooks/useFlatsGridState';
import { useChangeAddressAcceptance } from '../../../../../hooks/useChangeAddressAccpetance';
import { Modal } from 'antd';
import { useSelector } from 'react-redux';
import FlatDownloadReports from './FlatDownloadReports';
import useAwailableReportsAddress from '../../../../../queries/useAwailableReportsAddress';

const FlatDocuments = () => {
  const params = useParams();

  const currentFlat = useSelector(
    (state) => state.housingStockStore.currentFlat
  );

  const { openModal: openDocFormModal } = useChangeDocModalVisible();

  const { flatsGridQueryKey } = useFlatsGridState();

  const addressId = Number(params.pageTabId);

  const flatAttachmentsKeys = getQueryKeys.flatAttachments(addressId);

  const defaultDocData = {
    entity: docEntities.room,
    params: { id: addressId, keys: flatAttachmentsKeys },
    typeId: 1, //Общий
  };

  const { data: awailableReports } = useAwailableReportsAddress({
    staleTime: Infinity,
  });

  const { mutate: deleteDoc, isLoading: isDeleteDocLoading } =
    useDeleteDocMutation(defaultDocData);

  const { data: docs, isFetching: isDocsFetching } = useFlatAttachments(
    addressId,
    { staleTime: 10 * 1000 }
  );

  const { chengeAsync: chengeAcceptance, loading: loadingAcceptanceChange } =
    useChangeAddressAcceptance();

  const onDeleteDoc = async (value) => {
    if (value?.type?.id === 2) {
      const isTransmissionDocs = docs?.filter((doc) => doc.type.id === 2);

      if (
        isTransmissionDocs?.length === 1 &&
        currentFlat?.addressLifeCycle?.acceptanceStatusAddressLifeCycle?.id ===
          4
      ) {
        return Modal.confirm({
          title: ' Вы действительно хотите продолжить?',
          content:
            'Односторонняя передача должна быть обязательно подтверждена документом. При удалении подтверждающего документа статус приемки будет переведен в статус “Принято с замечаниями”.',
          okText: 'Да',
          okType: 'danger',
          cancelText: 'Нет',
          onOk: async () => {
            await chengeAcceptance({
              flatId: addressId,
              AcceptanceStatusId: 2,
              flatsGridQueryKey,
            });

            await deleteDoc(value);
          },
        });
      }
    }

    await deleteDoc(value);
  };

  const getAttachmentUrl = async (data) => {
    const fileName = typeof data === 'string' ? data : data.fileName;

    const fileExtension = fileName.split('.')[1];

    const attachment = await getFlatAttachment(addressId, fileName);

    const url = getBlobUrl(attachment, fileExtension);

    return url;
  };

  const docsSorted = useMemo(() => {
    return docs?.sort((a, b) => b.createDate.localeCompare(a.createDate)) || [];
  }, [docs]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <Documents
        docs={docsSorted}
        className={styles.grow}
        title={texts.flatDocuments}
        loading={
          isDocsFetching || isDeleteDocLoading || loadingAcceptanceChange
        }
        getAttachmentUrl={getAttachmentUrl}
        onDeleteDocument={onDeleteDoc}
        onAddBtnClick={() => openDocFormModal(defaultDocData)}
        onEditClick={(attachment) =>
          openDocFormModal({ ...defaultDocData, attachment })
        }
      />
      {Boolean(awailableReports?.length) && (
        <FlatDownloadReports awailableReports={awailableReports} />
      )}
    </div>
  );
};

export default FlatDocuments;
